import React from "react"
import { AppProvider } from "./AppProvider"

const RootElement = ({ children }) => {
  return <AppProvider>{children}</AppProvider>
}

export default RootElement
